/**
 * Controller for AppManager
 */
define('controllers/mysetting/teamaccount/add.member.account.account.ctrl',['app'], function (app) {
    app.controller('AddMemberAccountAccountCtrl', ['$q', '$scope', '$location', '$stateParams', '$state', '$filter', 'auiDialog', 'auiTeamAccountService',
        function ($q, $scope, $location, $stateParams, $state, $filter, auiDialog, auiTeamAccountService) {
            var Model = $scope.Model = {};
            Model.now = new Date(new Date().setDate(new Date().getDate() + 1));
            Model.template = {};
            Model.isUpdate = !!$stateParams.teamMemberInfo && $stateParams.teamMemberInfo.fakeMemberID;

            if (!Model.isUpdate) {
                auiTeamAccountService.getRealNameCountryList().then(function (data) {
                    Model.countryShortNameToCountyToPhone = data.realNameCountrys;
                });
            }

            Model.teamMemberInfo = $stateParams.teamMemberInfo ? $stateParams.teamMemberInfo : {};
            if (!Model.teamMemberInfo.expireTime || Model.teamMemberInfo.expireTime == "9999-12-31 23:59:59") {
                Model.teamMemberInfo.expireTime = "9999-12-31 23:59:59";
                Model.template.isSetTime = 1;
            } else {
                Model.teamMemberInfo.expireTime = $filter('auiDateFormat')(Model.teamMemberInfo.expireTime, '+0000');
                Model.template.isSetTime = 2;
            }
            $scope.isMemberLoginNamePhone = isMemberLoginNamePhone;
            $scope.isMemberLoginNameEmail = isMemberLoginNameEmail;
            $scope.setExpireTime = setExpireTime;
            $scope.nextStep = nextStep;
            $scope.cancel = cancel;
            $scope.checkNikeName = checkNikeName;
            $scope.changeI18nTelCode = changeI18nTelCode;
            if (Model.teamMemberInfo && Model.teamMemberInfo.i18nTelCode) {
                Model.accountType = 2;
                auiTeamAccountService.getRealNameCountryList().then(function (data) {
                    Model.countryShortNameToCountyToPhone = data.realNameCountrys;
                    Model.countryShortNameToCountyToPhone.forEach(function (key) {
                        if (key.i18nTelCode == Model.teamMemberInfo.i18nTelCode) {
                            Model.country = key;
                        }
                    })
                });
            } else {
                Model.country = {
                    "shortName": "中国",
                    "i18nTelCode": "86"
                };
            }


            //判断是否为开发者帐号
            function isMemberLoginNamePhone() {
                if (!Model.country) {
                    return false;
                }
                return (Model.country.i18nTelCode == 86 && AUI.BaseJSUtil.isMobile(Model.teamMemberInfo.memberLoginName)) || (Model.country.i18nTelCode != 86 && AUI.BaseJSUtil.isNationMobile(Model.teamMemberInfo.memberLoginName));
            }

            //检查昵称
            function checkNikeName() {
                return !AUI.BaseJSUtil.isNikeName(Model.teamMemberInfo.memberNickName);
            }

            function isMemberLoginNameEmail() {
                return AUI.BaseJSUtil.isEmail(Model.teamMemberInfo.memberLoginName);
            }

            function changeI18nTelCode(selected) {
                Model.country = selected;
            }


            //设置有效期
            function setExpireTime(type) {
                Model.template.isSetTime = type;
                if (type == 2 && Model.teamMemberInfo.expireTime == "9999-12-31 23:59:59") {
                    Model.teamMemberInfo.expireTime = Model.now;
                }
                if (type == 1 && !Model.teamMemberInfo.expireTime) {
                    Model.teamMemberInfo.expireTime = "9999-12-31 23:59:59"
                }
            }


            //下一步
            function nextStep() {
                var defer = $q.defer();
                $scope.addAccountForm.$setDirty(true);
                $scope.addAccountForm.memberLoginName.$setDirty(true);
                $scope.addAccountForm.memberEmail.$setDirty(true);
                $scope.addAccountForm.memberNickName.$setDirty(true);
                if (Model.template.isSetTime == 2 && !Model.teamMemberInfo.expireTime) {
                    auiDialog.warn("请选择到期日期");
                    defer.reject();
                    return defer.promise;
                }
                if ($scope.addAccountForm.$invalid || checkNikeName() || (Model.accountType == 1 && !isMemberLoginNameEmail()) || (Model.accountType == 2 && !isMemberLoginNamePhone())) {
                    defer.reject();
                    return defer.promise;
                }
                if (Model.template.isSetTime == 2 && new Date(angular.copy(Model.teamMemberInfo.expireTime)) < new Date()) {
                    Model.teamMemberInfo.expireTime = angular.copy(Model.now);
                }
                Model.teamMemberInfo.memberMsgLang = "zh_CN";
                if (Model.template.isSetTime == 1) {
                    Model.teamMemberInfo.expireTime = "9999-12-31 23:59:59";
                } else {
                    Model.teamMemberInfo.expireTime = $filter('auiDateFormat')($filter('date')((Model.teamMemberInfo.expireTime instanceof Date) ? Model.teamMemberInfo.expireTime : new Date(Model.teamMemberInfo.expireTime.replace(/-/g, '/')), "yyyy-MM-dd"), new Date().toString().split(' ')[5].split('GMT')[1], '+0000');
                    Model.teamMemberInfo.expireTime = $filter('date')((Model.teamMemberInfo.expireTime instanceof Date) ? Model.teamMemberInfo.expireTime : new Date(Model.teamMemberInfo.expireTime.replace(/-/g, '/')), "yyyy-MM-dd HH:mm:ss");
                }
                Model.accountType == 2 ? Model.teamMemberInfo.i18nTelCode = Model.country.i18nTelCode : Model.teamMemberInfo.i18nTelCode = "";
                auiTeamAccountService.getUserResourceListDetail(undefined, true).then(function () {
                    $state.go("mysetting.addMemberAccount.rolePermission", {
                        teamMemberInfo: Model.teamMemberInfo,
                        memberResInfo: $stateParams.memberResInfo
                    });
                });
                return defer.promise;
            }

            //取消
            function cancel() {
                $state.go("mysetting.teamAccountInfoList", {reload: true});
            }

            //监听 到期日期选择
            $scope.$watch('Model.teamMemberInfo.expireTime', function (newValue, oldValue) {
                if (newValue == oldValue) return;
                if (newValue != oldValue) {
                    if (Model.teamMemberInfo.expireTime && Model.teamMemberInfo.expireTime != "9999-12-31 23:59:59") {
                        Model.template.isSetTime = 2;
                    }
                }
            }, true);
        }]);
});
